import { DropdownItem, MultiSelectItem } from '@/main/store/@types/dropdown.d';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { UPDATE_BASIC_EDIT } from '@/main/store/listEditTypes';
import _ from 'lodash';
import { dataMapper } from '@/main/utils/dataMapper';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { AuthPracovnikInterface, ProvozovnyType, types } from './types';

const edit = {
	Auths: [] as AuthPracovnikInterface[],
	CmrozvrhId: null as number | null,
	DzcXcz: null as string | null,
	EMailAdresa: null as string | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EmiseOsvedc: null as string | null,
	EmiseOsvedcVznet: null as string | null,
	Jmeno: null as string | null,
	Memo: null as string | null,
	Obec: null as string | null,
	OsobniCis: null as string | null,
	OzakazkobjPrp: false,
	Oznam: null as string | null,
	PersoncardId: null as string | null,
	PersoncardvydPrp: false,
	PracovnikId: null as number | null,
	PracovnikOzn: null as string | null,
	Prijmeni: null as string | null,
	ProduktPrp: false,
	ProduktPrpt: false,
	ProvozovnaId: null as number | null,
	PscNr: null as string | null,
	Rodnecislo: null as string | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	TankomatNr: null as string | null,
	TankovaniPrp: false,
	TelfmaNr: null as string | null,
	TelmobNr: null as string | null,
	TelprivNr: null as string | null,
	TympracId: null as number | null,
	UkonceniDat: null as Date | null,
	Ulice: null as string | null,
	Uvazek: null as number | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VyrazenPrp: null as boolean | null,
	ProvNahl: [] as number[],
	ProvAktual: [] as number[],
	Sklady: [] as MultiSelectItem[],
	SkladyNV: [] as number[],
	SkladyOV: [] as number[],
	SkladyPredm: [] as number[],
	SkladyPneu: [] as number[],
	PujcovnyVoz: [] as number[],
	Pokladny: [] as number[],
	Provozovny: [] as ProvozovnyType[],
	UserSecondaryRole: [] as string[],
};

export type ProvozovnaIdDropDownList = DropdownItem & { selected: boolean };

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		CmrozvrhId: [],
		PracovnikOzn: [],
		UserSecondaryRole: [],
		ProvozovnaId: [] as ProvozovnaIdDropDownList[],
		TympracId: [],
		ProvNahl: [],
		ProvAktual: [],
		Scopes: [],
		Sklady: [],
		SkladyNV: [],
		SkladyOV: [],
		SkladyPredm: [],
		SkladyPneu: [],
		PujcovnyVoz: [],
		Pokladny: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[UPDATE_BASIC_EDIT](state, { data }: { data: any }) {
			if (data.DropDownList) {
				state.dropdownList = {
					...state.dropdownList,
					...data.DropDownList,
					ProvozovnaId: data.DropDownList.ProvozovnaId.map((item: DropdownItem) => ({ ...item, selected: false })),
				};
			}
			delete data.DropDownList;
			data.Operations && (state.operations = data.Operations);
			delete data.Operations;
			if (data.ValidationRules) {
				if (!_.isEmpty(data.ValidationRules)) {
					state.validationRules = data.ValidationRules;
				}
				delete data.ValidationRules;
			}
			dataMapper(state.edit, data);
		},
		[types.mutations.PRACOVNIK_NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
